const store = {
    namespaced: true,
    state: {
        pagination: {
            current_page: null,
            total_pages: null,
        },
        search_params: {},
        default_search_params: {
            name: null,
            en_name: null,
            core_waybill_level: null,
            class_name: null,
            label_type: null,
        },
        show_filter: false,
    },
    actions: {
    },
    mutations: {
        set_current_page(state, payload) {
            state.pagination.current_page = payload
        },
        set_total_pages(state, payload) {
            state.pagination.total_pages = payload
        },
        init_search_params(state) {
            state.search_params = state.default_search_params
        },
        toggle_filter(state) {
            state.show_filter = !state.show_filter
        },
    }
}

export default store
